var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bottom-scroll-bar"}},[_c('ul',_vm._l((_vm.categories),function(category,k){return _c('li',{key:k},[_c('i',{class:[k == _vm.actualCategory ? 'prendido fas ' + _vm.iconToDisplay : 'apagado fas fa-circle']})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bb04fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollBarComponent.vue
// module id = null
// module chunks = 